// extracted by mini-css-extract-plugin
export default {"contentSeparator":"ContentSeparator__contentSeparator--Gq"};